import * as React from "react";
function SvgDpitEllipsisHSolid(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path fill="currentColor" d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z" /></svg>;
}
export default __webpack_public_path__ + "main/assets/dpit-ellipsis-h-solid-803440b0.svg";
export { SvgDpitEllipsisHSolid as ReactComponent };